// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  PRESUPUESTADOR_GET_GASTOS_DE_ENTREGA_CHECKED,
} from './constants';

export function getGastosDeEntregaChecked(bool) {
  if(bool){
    return {
      type: PRESUPUESTADOR_GET_GASTOS_DE_ENTREGA_CHECKED,
      data: {
        gastosDeEntrega: 5000,
        client_license_plate: bool,
        will_get_costs: true,
        resetCostoPatentamiento: true,
      },
    };
  } else {
    return {
      type: PRESUPUESTADOR_GET_GASTOS_DE_ENTREGA_CHECKED,
      data: {
        client_license_plate: bool,
        will_get_costs: true,
        resetCostoPatentamiento: true,
      },
    };
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case PRESUPUESTADOR_GET_GASTOS_DE_ENTREGA_CHECKED:
      return {
        ...state,
        ...action.data
      };

    default:
      return state;
  }
}
